import { useEffect, useState } from 'react';

import { highlightKeys } from '../../../../../../features/candidateLayout/utils/cvHelper';

export const UseGetHighlightCVContent = (searchQuery: string, url: string) => {
  const [highLightedContent, setHighLightesContent] = useState<string>('');
  useEffect(() => {
    const response = async () => {
      const res = await fetch(url ?? '');
      const response = await res.text();
      const highlightedContent = highlightKeys(response, searchQuery);
      setHighLightesContent(highlightedContent);
    };
    url && response();
  }, [searchQuery, url]);
  return highLightedContent;
};
